import { useCareCreditEnrollmentContext } from '../../context/care-credit-enrollment.context';
import { CareCreditEnrollmentMultiSteps } from '../../enrollment-multi-step.types';

type EnrollmentStepPerformanceWrapperProps = React.PropsWithChildren<{
  step: CareCreditEnrollmentMultiSteps;
}>;

export const EnrollmentStepPerformanceWrapper = ({ children, step }: EnrollmentStepPerformanceWrapperProps) => {
  const {
    multiStep: { activeStep },
  } = useCareCreditEnrollmentContext();

  if (step !== activeStep) return null;

  return <>{children}</>;
};
